import { Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BillingFormComponent } from 'ngx-intellforce-billing/lib/components/billing-form/billing-form.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AppComponent implements OnInit {
  currentyear: any;
  weekago: any;
  threedaysago: any;
  showLine: boolean = false;
  @ViewChild('form', { static: true }) form: BillingFormComponent;

  constructor() {}

  ngOnInit(): void {
    this.yesterday = new Date();

    this.threedaysago = new Date();
    this.threedaysago.setDate(new Date().getDate() - 3);
	
    this.weekago = new Date();
    this.weekago.setDate(new Date().getDate() - 8);

    this.currentyear = new Date();
    this.currentyear.setDate(new Date().getDate());

    this.form.formGroup.addControl('language', new FormControl(window.navigator.language));
    this.form.formGroup.addControl('screenHeight', new FormControl(window.screen.height));
    this.form.formGroup.addControl('screenWidth', new FormControl(window.screen.width));
    this.form.formGroup.addControl('timezone', new FormControl(new Date().getTimezoneOffset()));
    this.form.formGroup.addControl('javaEnabled', new FormControl(window.navigator.javaEnabled()));
    const newLocal = this;
    newLocal.form.formGroup.addControl('javascriptEnabled', new FormControl(true));
    this.form.formGroup.addControl('screenColorDepth', new FormControl(window.screen.colorDepth));
  }

  title = 'boxes';
  yesterday: Date;
  isShowFaq = true;
  toggleDisplayFaq() {
    this.isShowFaq = !this.isShowFaq;
  }

  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  isHideButton = false;
  isShowForm = false;
  showFormMobile() {
    this.isShowForm = true;
    this.isHideButton = true;
  }

}
